<div class="p-d-flex p-flex-column p-fluid">
  <div class="even-columns gap-12 p-d-flex p-flex-row p-flex-wrap">
    <kodit-field class="p-mr-2" class="flex-1-1-100" fieldLabel="Broj koleta">
      <kodit-number-input-field
        formCtrlId="broj-koleta"
        [formCtrl]="racunForm.controls.koleto"
      ></kodit-number-input-field>
    </kodit-field>
    <kodit-field class="p-mr-2" class="flex-1-1-100" fieldLabel="Broj paleta">
      <kodit-number-input-field
        formCtrlId="broj-paleta"
        [formCtrl]="racunForm.controls.brojPaleta"
      ></kodit-number-input-field>
    </kodit-field>
    <kodit-field class="p-mr-2" class="flex-1-1-100" fieldLabel="Broj ramova">
      <kodit-number-input-field
        formCtrlId="broj-ramova"
        [formCtrl]="racunForm.controls.brojRamova"
      ></kodit-number-input-field>
    </kodit-field>
    <kodit-field class="p-mr-2" class="flex-1-1-100" fieldLabel="Neto težina">
      <kodit-number-input-field
        formCtrlId="neto-tezina"
        [formCtrl]="racunForm.controls.netoTezina"
      ></kodit-number-input-field>
    </kodit-field>
    <kodit-field class="p-mr-2" class="flex-1-1-100" fieldLabel="Bruto težina">
      <kodit-number-input-field
        formCtrlId="bruto-tezina"
        [formCtrl]="racunForm.controls.brutoTezina"
      ></kodit-number-input-field>
    </kodit-field>
  </div>
</div>
